import * as Account from './codes/account.codes.js';
import * as Attachments from './codes/attachments.codes.js';
import * as Auth from './codes/auth.codes.js';
import * as AutomationsV2 from './codes/automations-v2.codes.js';
import * as Automations from './codes/automations.codes.js';
import * as BulkActions from './codes/bulk-actions.codes.js';
import * as Card from './codes/card.codes.js';
import * as Database from './codes/database.codes.js';
import * as Deadline from './codes/deadline.codes.js';
import * as FeatureFlag from './codes/feature-flag.codes.js';
import * as Feature from './codes/features.codes.js';
import * as Field from './codes/field.codes.js';
import * as Form from './codes/form.codes.js';
import * as Generic from './codes/generic.codes.js';
import * as Interpolation from './codes/interpolation.codes.js';
import * as Label from './codes/label.codes.js';
import * as Notification from './codes/notification.codes.js';
import * as Permissions from './codes/permissions.codes.js';
import * as Pipe from './codes/pipe.codes.js';
import * as Review from './codes/review.codes.js';
import * as Role from './codes/role.codes.js';
import * as ServiceAccount from './codes/service-account.codes.js';
import * as Stage from './codes/stage.codes.js';
import * as Teams from './codes/teams.codes.js';
import * as Template from './codes/template.codes.js';
import * as Upload from './codes/upload.codes.js';
import * as User from './codes/user.codes.js';
import * as Validation from './codes/validation.codes.js';

/**
 * Objeto com todos os códigos de erro disponíveis no Flux. Esse objeto guarda os códigos
 * de erro agrupados por categoria, facilitando o acesso e a manutenção dos mesmos.
 * **Todas as outras variáveis desse pacote são derivadas dessa constante.**
 */
export const FluxErrors = {
  ...Generic.GenericErrorCodes,
  ...Account.AccountErrorCodes,
  ...Attachments.AttachmentErrorCodes,
  ...Auth.MfaErrorCodes,
  ...Auth.PasswordResetErrorCodes,
  ...Auth.RecoveryCodesErrorCodes,
  ...Auth.SignInErrorCodes,
  ...Automations.AutomationActionErrorCodes,
  ...Automations.AutomationErrorCodes,
  ...Automations.SyncAutomationErrorCodes,
  ...AutomationsV2.AutomationV2ActionErrorCodes,
  ...AutomationsV2.AutomationV2AutocompleteErrorCodes,
  ...AutomationsV2.AutomationV2ErrorCodes,
  ...AutomationsV2.AutomationV2ExecutionActionErrorCodes,
  ...AutomationsV2.AutomationV2ExecutionActionGenericErrorCodes,
  ...AutomationsV2.AutomationV2ExecutionErrorCodes,
  ...AutomationsV2.AutomationV2RoleErrorCodes,
  ...AutomationsV2.AutomationV2TriggerConditionErrorCodes,
  ...AutomationsV2.AutomationV2TriggerErrorCodes,
  ...AutomationsV2.AutomationV2VersionErrorCodes,
  ...BulkActions.BulkActionsErrorCodes,
  ...Card.CardAssigneeErrorCodes,
  ...Card.CardAttachmentErrorCodes,
  ...Card.CardCommentAttachmentErrorCodes,
  ...Card.CardCommentErrorCodes,
  ...Card.CardDeadlineErrorCodes,
  ...Card.CardErrorCodes,
  ...Card.CardReviewErrorCodes,
  ...Card.CardSolicitationErrorCodes,
  ...Card.CardTaskAssigneeErrorCodes,
  ...Card.CardTaskErrorCodes,
  ...Card.CardTaskLabelErrorCodes,
  ...Database.DatabaseErrorCodes,
  ...Database.DatabaseIdLookupErrorCodes,
  ...Database.DatabaseMemberErrorCodes,
  ...Database.DatabaseRecordErrorCodes,
  ...Database.DatabaseSchemaErrorCodes,
  ...Deadline.DeadlineErrorCodes,
  ...Feature.FeaturesErrorCodes,
  ...FeatureFlag.FeatureFlagAccountErrorCodes,
  ...FeatureFlag.FeatureFlagErrorCodes,
  ...Field.FieldErrorCodes,
  ...Form.FormErrorCodes,
  ...Form.StageCardFormErrorCodes,
  ...Form.StageFormErrorCodes,
  ...Interpolation.InterpolationErrorCodes,
  ...Interpolation.InterpolationHelperErrorCodes,
  ...Label.LabelErrorCodes,
  ...Notification.NotificationErrorCodes,
  ...Notification.NotificationPreferenceErrorCodes,
  ...Permissions.PermissionErrorCodes,
  ...Pipe.PipeErrorCodes,
  ...Pipe.PipeIdLookupErrorCodes,
  ...Review.ReviewerErrorCodes,
  ...Review.ReviewErrorCodes,
  ...Role.RoleErrorCodes,
  ...Stage.StageErrorCodes,
  ...Teams.TeamErrorCodes,
  ...Teams.TeamsMembersErrorCodes,
  ...Template.TemplateDeadlineErrorCodes,
  ...Template.TemplateErrorCodes,
  ...Template.TemplateReviewErrorCodes,
  ...Upload.UploadErrorCodes,
  ...User.UserErrorCodes,
  ...User.UserInviteErrorCodes,
  ...User.UserLicenseErrorCodes,
  ...Validation.CastValueErrorCodes,
  ...Validation.ValidationErrorCodes,
  ...Validation.WorkflowErrorCodes,
  ...ServiceAccount.ServiceAccountErrorCodes,
} as const;

export type FluxErrorMessagesType = typeof FluxErrors;
